import { render, staticRenderFns } from "./editStudent.vue?vue&type=template&id=4b8630b4&scoped=true&"
import script from "./editStudent.vue?vue&type=script&lang=js&"
export * from "./editStudent.vue?vue&type=script&lang=js&"
import style0 from "./editStudent.vue?vue&type=style&index=0&lang=less&"
import style1 from "./editStudent.vue?vue&type=style&index=1&id=4b8630b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8630b4",
  null
  
)

export default component.exports